import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b88b4130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tools-buttons" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Start ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Start ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "divMessages",
  class: "messages"
}, null, -1))
const _hoisted_5 = { class: "input-zone" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope" }, null, -1))

import Card from '@/components/card/card.vue';
import AppInput from '@/components/input/input.vue';
import AppButton from '@/components/button/button.vue';
import {useI18n} from 'vue-i18n';
import * as signalR from '@microsoft/signalr';
import {onMounted, ref} from 'vue';
import {HubConnection, IHttpConnectionOptions} from '@microsoft/signalr';

import {getPropertyName} from '@fluffy-spoon/name-of';
import * as yup from 'yup';
import {useToast} from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const toast = useToast();
const {t} = useI18n();
const divMessages = ref();
onMounted(() => {
  console.log('mounted');
  divMessages.value = document.getElementById('divMessages');
});

const username = new Date().getTime();
const message = ref<string>('');
const apikey = ref<string>('');
const connectionStarted = ref<boolean>(false);

let connection: HubConnection = null;

const startConnection = () => {
  const options: IHttpConnectionOptions = {
    headers: {ApiKey: apikey.value}
    // accessTokenFactory: () => {
    //   const token = store.getters['auth/token'];
    //   return token;
    // }
  };

  connection = new signalR.HubConnectionBuilder()
    .withUrl(process.env.VUE_APP_API_ENDPOINT + 'hubs/chat', options)
    .build();
  connection.on('messageReceived', (username: string, message: string) => {
    const m = document.createElement('div');
    m.innerHTML = `<div><span class="message-author">${username}: </span>${message}</div>`;
    divMessages.value.appendChild(m);
    divMessages.value.scrollTop = divMessages.value.scrollHeight;
  });
  connectionStarted.value = true;
  connection.start()
      .then(() =>{
        toast.success("Connection started!");
        connectionStarted.value = true;
      })
      .catch((err: any) => {
        toast.error("Connection error: " + err.message);
        connectionStarted.value = false;
    // document.write(err);
    // const m = document.createElement('div');
        // m.innerHTML = `<div class="message-author">${username}</div><div class="text-danger">${err.message}</div>`;
        // divMessages.value.appendChild(m);
        // divMessages.value.scrollTop = divMessages.value.scrollHeight;
  });
};

const stopConnection = () =>{
  connection.stop();
  connectionStarted.value = false;
}

const send = () => {
  connection.send('newMessage', message.value).then(() => {
    message.value = '';
  });
};
const messageKeyUp = (e: KeyboardEvent) => {
  if (e.key === 'Enter') {
    send();
  }
};

const apikeyValidationRule = () => yup.string().required();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    title: _unref(t)('areas.chat.title')
  }, {
    tools: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AppInput, {
          type: "text",
          name: _unref(getPropertyName)((u) => _ctx.apiKey),
          label: _unref(t)('areas.chat.labels.apiKey'),
          "validation-enabled": true,
          "validation-rule": apikeyValidationRule,
          modelValue: _ctx.apiKey,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiKey) = $event)),
          readonly: connectionStarted.value
        }, null, 8, ["name", "label", "modelValue", "readonly"]),
        _createVNode(AppButton, {
          disabled: connectionStarted.value,
          class: "btn btn-success",
          icon: "play",
          onClick: startConnection
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(AppButton, {
          disabled: !connectionStarted.value,
          class: "btn btn-danger",
          icon: "stop",
          onClick: stopConnection
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(AppInput, {
          onkeyup: messageKeyUp,
          modelValue: message.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message).value = $event)),
          name: _unref(getPropertyName)((u) => message.value),
          class: "input-zone-input",
          type: "text",
          label: _unref(t)('areas.chat.labels.message'),
          "validation-enabled": false
        }, null, 8, ["modelValue", "name", "label"]),
        _createVNode(AppButton, {
          class: "btn btn-primary",
          onClick: send
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('areas.chat.labels.send')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})